import {
  DynamicAttributeFieldLocalizedFragment,
  LocalizedValueInput,
} from "gql/graphql";
import { AnyInput } from "@/shared/dynamic-attributes/ui/dynamic-attribute-field/dynamic-attribute-field-input-types";
import Form from "@/shared/form/form";
import { LocalizedValue } from "@/shared/form/localized-value";
import Input from "@/shared/form/input";

type DynamicAttributeFieldLocalizedProps = AnyInput<{
  meta: DynamicAttributeFieldLocalizedFragment;
}>;

type FieldsType = {
  localizedValue: LocalizedValueInput;
};

export function DynamicAttributeFieldLocalized({
  meta,
  value,
  onChange,
}: DynamicAttributeFieldLocalizedProps) {
  const [form] = Form.useForm<FieldsType>();

  return (
    <Form
      component={false}
      form={form}
      initialValues={
        value
          ? ({
              localizedValue: JSON.parse(value),
            } as FieldsType)
          : undefined
      }
      onFieldsChange={form.submit}
      onFinish={(values) => {
        onChange(JSON.stringify(values.localizedValue));
      }}
    >
      <LocalizedValue
        label={meta.name.value}
        name={"localizedValue"}
        render={({ placeholder }) => <Input placeholder={placeholder} />}
      />
    </Form>
  );
}
